import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=7ea7a84c&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=js&"
export * from "./ReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=7ea7a84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea7a84c",
  null
  
)

export default component.exports